<template>
  <action-tracker 
    ref='actionTracker' 
    :items='items'
    :is_loading='is_loading'
    :is_saving='is_saving'
    @save="handleSave"
    @update="handleUpdate"
  ></action-tracker>
</template>

<script>
import ActionTracker from './ActionTracker';
import trackerAPI from '@/api/tracker';
import formRules from '@/mixins/formRules';

export default {
  name: 'work-order-tracker',
  mixins: [formRules],
  props: {
    work_order: { required: false },
  },
  data: () => ({
    is_loading: true,
    is_saving: false,
    items: [],
    id: 0,
    description: '',
    action_date: '',
    showDialog: false,
    isFormValid: false,
    icon: 'mdi-message-text'
  }),
  computed: {
    headers () {
      return [
        { text: 'Date & Time', value: 'taken_on', width: '230' },
        { text: 'Added By', value: 'taken_by', width: '170' },
        { text: this.textTitle, value: 'description' },
        { text: '', value: 'options', align: 'right' }
      ]
    },
  },
  mounted () {
    this.getActions()
  },
watch: {
  work_order() {
    this.getActions();
    console.log(this.work_order.id);
  }
},
  methods: {
    async getActions () {
      const actions = await trackerAPI.getWorkOrderTracker(this.work_order.id);
      console.log(JSON.parse(JSON.stringify(actions)));
      this.items = [];
      this.createItems(actions);
      this.is_loading = false
    },
    createItems(action){
        action.map(action => {
            this.items.push(action.tracker_data);
        });
    },
    pushItem(action){
      this.items.push(action.tracker_data);
    },
    async handleSave(data){
        this.is_saving = true;
        const tracker_data = {
            'description': data.description,
            'taken_by': this.$store.state.auth.profile.id,
            'action_date': data.action_date
        }
        const tracker = {
            'tracker_data': tracker_data,
            'work_order': this.work_order.id
        }
        const response = await trackerAPI.createWorkOrderTracker(tracker);
        this.items.push(response.tracker_data);
        this.is_saving = false;
        this.id = 0;
    },
    async handleUpdate(data, id){
        this.is_saving = true;
        const tracker = {
            'description': data.description,
            'action_date': data.action_date,
            'taken_by': data.taken_by
        }
        const response = await trackerAPI.updateTracker(id, tracker);
        const index = this.items.findIndex(item => {
          return item.id === id;
        });
        this.items.splice(index, 1, response);
        this.is_saving = false;
    }
  },
  components: {
    'action-tracker': ActionTracker
  }
}
</script>
